import styled from "styled-components";

export const StaffManagementStyles = styled.div`
  .headerCard {
    margin-bottom: ${({ theme }) => theme.spacing[16]};
  }

  .header {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .addStaff {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .searchBar {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[12]};
    width: 100%;
  }

  .tableCard {
    overflow: hidden;
  }

  .searchContainer {
    width: 280px;
    height: 42px;
    border-radius: ${({ theme }) => theme.radius[12]};
    border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
    overflow: hidden;
    color: ${({ theme }) => theme.colors.semantic.icon.weak};
    transition: border-color 0.2s ease, color 0.2s ease;

    &:focus-within {
      border-color: ${({ theme }) => theme.colors.semantic.text.strong};
      color: ${({ theme }) => theme.colors.semantic.icon.strong};
    }

    .searchInput {
      border: none;
      border-radius: 0;
    }
  }
`;
